<template>
  <div class="row d-flex justify-content-center">
    <div class="col-md-6">
      <div class="mb-4 text-center">
        <h4>{{ 'Enter payment card details' | translate }}</h4>
      </div>

      <PayuCardForm></PayuCardForm>

      <div class="d-grid mt-2">
        <button @click="submit" class="btn btn-dark" :disabled="loading">
          {{ 'Confirm and pay' | translate }}
        </button>
      </div>

      <div v-if="has(errors, 'cypher')" class="text-danger mb-4">
        {{ 'Card data is not valid' | translate }}
      </div>
      <div v-if="has(errors, 'sale')" class="text-danger mb-4">
        {{ errors.sale[0] | translate }}
      </div>
      <div v-if="has(errors, 'membership')" class="text-danger mb-4">
        {{ errors.membership[0] | translate }}
      </div>

      <div class="mt-3">
        {{ 'When you update your card details, the system will collect the payment' | translate }}.
        {{ 'Thus extending access to the platform' | translate }}.
      </div>
    </div>
  </div>
</template>

<script>
import PayuCardForm from '~/checkout/components/membership/PayuCardForm'
import _ from 'lodash'

export default {
  components: {
    PayuCardForm,
  },
  props: ['publicRsaProp'],
  data: () => ({
    errors: {},
    loading: false,
    cypher: null,
  }),
  mounted() {},
  methods: {
    payuTokenize() {
      return window.payu
        .tokenize('MULTI')
        .then((result) => {
          result.status === 'SUCCESS' ? (this.cypher = result.body.token) : (this.errors.sale = ['Card problem'])
        })
        .catch((error) => {
          this.errors.card = ['Card problem']
        })
    },
    has: _.has,
    submit() {
      this.loading = true
      this.payuTokenize()
        .then(() => {
          return axios.post('/my/membership/card', {
            cypher: this.cypher,
          })
        })
        .then(({ data }) => {
          if (data.redirect) {
            window.location.href = data.redirect
          }
        })
        .catch((error) => {
          this.loading = false
          this.errors = _.get(error, 'response.data.errors')
        })
    },
  },
}
</script>

<style></style>
